import React from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationArrow } from '@fortawesome/free-solid-svg-icons';

export default ({ searchByLocation }) => (
  <SearchByLocation
    onClick={searchByLocation}
  >
    <FontAwesomeIcon icon={faLocationArrow} />
  </SearchByLocation>
);

const SearchByLocation = styled.div`
  animation: fadeInLeft 1s ease-out forwards;
  animation-delay: .8s;
  transition: all .3s ease-in-out;

  ${tw`
    absolute right-0 bottom-0 mb-10 mr-3 bg-white z-30
    h-16 w-16 rounded-full shadow-lg cursor-pointer invisible flex
    items-center justify-center text-2xl border border-black border-2
  `};

  @media (min-width: 768px) {
    ${tw`
      mr-6
    `};
  }
`;
